import React from "react";

const LineItems = ({ lineItems, setLineItems }) => {
    const handleChange = (index, field, value) => {
        const updated = [...lineItems];
        updated[index][field] = value;

        // auto calculate total
        const igst_amount = parseFloat(updated[index].igst_amount) || 0;
        const cgst_amount = parseFloat(updated[index].cgst_amount) || 0;
        const sgst_amount = parseFloat(updated[index].sgst_amount) || 0;
        const taxable_value = parseFloat(updated[index].taxable_value) || 0;

        updated[index].line_total = igst_amount + cgst_amount + sgst_amount + taxable_value;

        setLineItems(updated);
    };

    const addItem = () => {
        setLineItems([
            ...lineItems,
            {
                description: "",
                quantity: "",
                taxable_value: "",
                rate: "",
                igst_amount: "",
                cgst_amount: "",
                sgst_amount: "",
                line_total: "",
            }
        ]);
    };

    const removeItem = (index) => {
        const updated = lineItems.filter((_, i) => i !== index);
        setLineItems(updated);
    };

    return (
        <>
            <h3>Line Items</h3>

            {lineItems.map((item, index) => (
                <div key={index} className="line-item-row">
                    <input
                        placeholder="Description"
                        value={item.description}
                        onChange={(e) =>
                            handleChange(index, "description", e.target.value)
                        }
                    />

                    <input
                        type="number"
                        placeholder="Quantity"
                        value={item.quantity}
                        onChange={(e) =>
                            handleChange(index, "quantity", e.target.value)
                        }
                    />

                    <input
                        type="number"
                        placeholder="Taxable Value"
                        value={item.taxable_value}
                        onChange={(e) =>
                            handleChange(index, "taxable_value", e.target.value)
                        }
                    />

                    <input
                        type="number"
                        placeholder="Rate in %"
                        value={item.rate}
                        onChange={(e) =>
                            handleChange(index, "rate", e.target.value)
                        }
                    />

                    <input
                        type="number"
                        placeholder="Integrated GST in Rupees"
                        value={item.igst_amount}
                        onChange={(e) =>
                            handleChange(index, "igst_amount", e.target.value)
                        }
                    />

                    <input
                        type="number"
                        placeholder="Central GST in Rupees"
                        value={item.cgst_amount}
                        onChange={(e) =>
                            handleChange(index, "cgst_amount", e.target.value)
                        }
                    />

                    <input
                        type="number"
                        placeholder="State GST in Rupees"
                        value={item.sgst_amount}
                        onChange={(e) =>
                            handleChange(index, "sgst_amount", e.target.value)
                        }
                    />

                    <input
                        value={item.line_total}
                        placeholder="Total"
                        onChange={(e) =>
                            handleChange(index, "line_total", e.target.value)
                        }
                    />

                    <button type="button" onClick={() => removeItem(index)}>
                        ❌
                    </button>
                </div>
            ))}

            <button type="button" onClick={addItem}>+ Add Line Item</button>
        </>
    );
};

export default LineItems;